import { render, staticRenderFns } from "./salesRefundApplyInitList.vue?vue&type=template&id=b667d688&scoped=true"
import script from "./salesRefundApplyInitList.vue?vue&type=script&lang=js"
export * from "./salesRefundApplyInitList.vue?vue&type=script&lang=js"
import style0 from "./salesRefundApplyInitList.vue?vue&type=style&index=0&id=b667d688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b667d688",
  null
  
)

export default component.exports